<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qud8sQ/tc-custom/9781460323311.jpg?1703655943613" alt="This image is the cover for the book Amish Christmas Joy, Brides of Amish Country"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amish Christmas Joy, Brides of Amish Country
      </h1>
      <p class="bookDescription body article font2">
        <p>Instant Father <br/><br/>One minute, Caleb Mast is an oil-rig roughneck who answers to no one but himself. The next, he's the father of a special-needs child he never knew existed. What kind of home can a man like himwithout faith or communityprovide for an eight-year-old girl? For little Joy's sake, Caleb returns to the Amish community he left behind years ago. His daughter bonds with Amish schoolteacher Leah Belier, and Caleb feels hopeful for once. But Leah blames Caleb for dashing long-ago dreams and can't bear to trust him. With Christmas weeks away, one special girl just may bring two heartsand an entire communitytogether. <br/><br/>Brides of Amish Country: Finding true love in the land of the Plain People. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Davids
      </h2>
      
      <p class="authorDescription body article">USA Today best-selling author Patricia Davids was born in Kansas. After forty years as an NICU nurse, Pat switched careers to become an inspirational writer. She now enjoys laid back life on a Kansas farm, spending time with her family and playing with her dog Sugar, who thinks fetch should be a twenty-four hour a day game. When not throwing a ball, Pat is happily dreaming up new stories where love and faith conquer all. Contact her at pat@patriciadavids.com.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5607cdf8